import { type FC } from 'react'

import styled from 'styled-components'

import { Input } from 'src/Components/Input/index.tsx'
import { device } from 'src/Helpers/constants.ts'

const StyledInput = styled(Input)`
  width: 400px;

  @media ${device.tabletMax} {
    width: 100%;
  }
`

const ControlsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
  height: 41px;
`

interface SearchBlockProps {
  value: string
  onChange: (value: string) => void
}

export const SearchBlock: FC<SearchBlockProps> = ({ value, onChange }) => {
  return (
    <ControlsContainer>
      <StyledInput
        placeholder='Поиск по клиенту или номеру договора'
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </ControlsContainer>
  )
}
